import axios from "axios";
import { LOGOUT_URL } from "./urls/clientApiHandler";

export const logoutAuth = () => {
    return axios.get(LOGOUT_URL());
};